import { Grid } from "@mui/material";

import { milesToKm } from "@aclymatepackages/converters";
import { TextField } from "@aclymatepackages/atoms";
import { numbersRegExpTest } from "@aclymatepackages/reg-exp";

import useInputMeasurementSystem from "../../helpers/hooks/inputMeasurementSystem";

const DistanceInput = ({
  distance,
  editTransaction,
  oldDbMileageValue,
  clearOtherInputs = () => {},
  disabled,
}) => {
  const { measurementSystem } = useInputMeasurementSystem();

  const isImperial = measurementSystem === "imperial";

  const distanceLabel = isImperial ? "Miles" : "Kilometers";

  const fetchDisplayValue = () => {
    if (!distance && !oldDbMileageValue) {
      return "";
    }

    if (distance) {
      return distance;
    }

    const displayValue = isImperial
      ? oldDbMileageValue
      : milesToKm(oldDbMileageValue);

    return displayValue;
  };

  const onEditDistance = (value) => {
    clearOtherInputs();
    const valueUnit = isImperial ? "miles" : "kms";
    editTransaction("distanceUnit")(valueUnit);
    return editTransaction("distance")(value);
  };

  return (
    <Grid item xs={12}>
      <TextField
        label={distanceLabel}
        value={fetchDisplayValue()}
        setValue={onEditDistance}
        helperText={
          distance && !numbersRegExpTest(distance) && "This must be a number"
        }
        error={distance && !numbersRegExpTest(distance)}
        disabled={disabled}
      />
    </Grid>
  );
};
export default DistanceInput;
